module.exports = __webpack_public_path__ + "static/media/exp_beach_2.b3f0e6aa.svg";